import React from 'react';
function Signature(_ref) {
  let {
    color = '#335B70',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.61 15.232c-.429.965-.85 1.851-1.357 2.868-.14.283-.67 1.336-.556 1.11l-.011.02-.003.006-.001.004.015-.03c-.193.384-.318.638-.425.863l-.12.26c.34-.2.834-.51 1.508-.947l.06-.038c1.196-.776 1.765-1.114 2.26-1.292 1.196-.43 1.708.515 1.089 1.762-.518 1.043-.659.962 1 .119.324-.165.712-.02.867.324.155.344.018.756-.305.92-2.396 1.22-3.755.64-2.956-1.455-.319.186-.73.444-1.278.8l-.06.039C15.491 21.762 15.081 22 14.568 22c-.643 0-1.038-.493-.956-1.16.042-.343.196-.747.499-1.387.094-.2.2-.416.349-.713l.077-.157.004-.006.009-.02.003-.005.006-.01.545-1.087c.39-.783.727-1.485 1.057-2.206-.323.291-.698.651-1.116 1.07-1.598 1.607-3.923 4.22-4.9 5.438a.624.624 0 01-.916.078.72.72 0 01-.074-.973c1.007-1.256 3.364-3.904 4.997-5.545 1.098-1.104 1.918-1.821 2.453-2.1 1.425-.74 1.668.524 1.005 2.015zm-4.552-9.863l3.75 3.958L5.749 21H2v-3.958L13.058 5.37zm2.9-3.06a.96.96 0 011.41 0l2.34 2.47c.39.411.39 1.076 0 1.487l-1.83 1.932-3.75-3.958z",
    fill: color,
    fillRule: "evenodd"
  }));
}
export default Signature;